import Layout from '@layout/Index'

export const platformUpload = [
  {
    path: '/platform-upload',
    component: Layout,
    children: [
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "platform-upload-table" */ './pages/PlatformUploadTable.vue'),
        name: '平台列表',
        meta: {
          title: '平台列表',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/platform-upload/platform-upload.route.js